import { Avatar, Grid, Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
const useStyles = makeStyles({
  root: {
    "&.MuiGrid-root": {
      overflow: "hidden",
      margin: "1rem",
      minWidth: "100px",
      minHeight: "100px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-evenly",
      alignItems: "center",
      border: "double 3px transparent",
      borderRadius: "10px",
      borderImageSlice: "1",
      borderWidth: "3px",
      backgroundImage:
        "linear-gradient(#1a1a1a, #1a1a1a),radial-gradient(circle at top left, #51a2e9, #ff4d5a)",
      backgroundOrigin: "border-box",
      backgroundClip: "content-box, border-box",
    },
  },
  title: {
    "&.MuiTypography-root": {
      color: "#ff4d5a",
      fontFamily: "Orbitron, sans-serif",
      fontWeight: "500",
      fontSize: "1rem",
      letterSpacing: "0.48899em",
    },
  },
});

function ExpertItems(props) {
  const classes = useStyles();
  const { componentSkill } = props;
  return (
    <Grid container justifyContent="flex-end">
      {componentSkill.map((item) => (
        <Grid item md key={item.title2} className={classes.root}>
          <Stack>
            <Avatar alt={item.alt} src={item.image} variant="rounded"></Avatar>
          </Stack>
          <Typography variant="subtitle1" className={classes.title}>
            {item.title2.toUpperCase()}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
}

export default ExpertItems;
